import pic from "../../assets/img/user_pic.jpg";
import yallaLodo from "../../assets/img/yalla-lodo-landscape.png";
import pubg from "../../assets/img/pupg.png";
import playstation from "../../assets/img/playstation.png";
import flag from "../../assets/svg-flags/Saudi-Flag.svg";

const user = {
    id: 1,
    name: "محمد الشاذلى",
    email: "elshazly@elshazly.com",
    phone: "01010920806",
    pic: pic,
    country: "Eg"
};

const items = [
    {
        id: 1,
        name: "يلا لودو 50 دولار",
        img: yallaLodo,
        store: "المتجر السعودى",
        storeFlag: flag,
        price: 90,
        count: 1,
        currancy: "ر.س",
        cardCode: "X7U**98X7U**98X7U**98X7U**98",
        serial: "16362rtdtvhjcsryter76475q4"
    },
    {
        id: 2,
        name: "حساب بلايستشن 6 شهور",
        img: playstation,
        store: "المتجر السعودى",
        storeFlag: flag,
        price: 200,
        count: 1,
        currancy: "ر.س",
        cardCode: "X7U**98X7U**98X7U**98X7U**98",
        serial: "16362rtdtvhjcsryter76475q4"
    },
    {
        id: 2,
        name: "بطاقة شحن شدات ببجى",
        img: pubg,
        price: 120,
        count: 1,
        currancy: "ر.س",
        cardCode: "X7U**98X7U**98X7U**98X7U**98",
        serial: "16362rtdtvhjcsryter76475q4"
    }
];

const order = {
    id: 1,
    details: {
        condition: 1, // 1 means order complete, 0 means order not completed
        payMethod: "Apple Pay",
        date: "17/10/2023",
        time: "13:36"
    },
    total: 410,
    currancy: "ر.س",
    items
};

const order2 = order;
order2.id = 2;

const order3 = order;
order3.id = 3;

const orders = [order, order2, order3];

export { user, items, orders, order };
